/**
 * Shared firework/particle burst effect.
 * No dependencies. Injects its own CSS on first use.
 */

var FIREWORK_COLORS = ['#e84393', '#f472b6', '#38bdf8', '#fbbf24', '#a78bfa', '#fff', '#34d399'];
var cssInjected = false;

function injectCss() {
	if (cssInjected) return;
	cssInjected = true;
	var s = document.createElement('style');
	s.textContent = '\
.fw-particle{position:absolute;border-radius:50%;pointer-events:none;animation:fwBurst var(--fw-dur,0.8s) cubic-bezier(0.25,0.46,0.45,0.94) var(--fw-delay,0s) forwards;opacity:0;z-index:100002}\
@keyframes fwBurst{0%{opacity:1;transform:translate(0,0) rotate(0) scale(1)}70%{opacity:0.8}100%{opacity:0;transform:translate(var(--fx,0),var(--fy,0)) rotate(var(--fr,0)) scale(0)}}';
	document.head.appendChild(s);
}

/**
 * Fire particle bursts inside a container.
 * @param {HTMLElement} container - positioned element to spawn particles in
 * @param {number} burstCount - number of burst origins
 * @param {number} particlesPerBurst - particles per burst
 * @param {number} delayBase - base delay in seconds
 */
export function fireFireworks(container, burstCount, particlesPerBurst, delayBase) {
	injectCss();
	var w = container.offsetWidth || window.innerWidth;
	var h = container.offsetHeight || window.innerHeight;
	for (var b = 0; b < burstCount; b++) {
		var bx = Math.random() * w;
		var by = Math.random() * h;
		var bDelay = (delayBase || 0) + b * 0.15;
		for (var i = 0; i < particlesPerBurst; i++) {
			var p = document.createElement('div');
			p.className = 'fw-particle';
			var sz = 3 + Math.random() * 7;
			p.style.width = sz + 'px';
			p.style.height = sz + 'px';
			p.style.background = FIREWORK_COLORS[Math.floor(Math.random() * FIREWORK_COLORS.length)];
			p.style.left = bx + 'px';
			p.style.top = by + 'px';
			var angle = Math.random() * Math.PI * 2;
			var dist = 30 + Math.random() * 120;
			p.style.setProperty('--fx', Math.cos(angle) * dist + 'px');
			p.style.setProperty('--fy', Math.sin(angle) * dist + 'px');
			p.style.setProperty('--fr', (Math.random() * 720 - 360) + 'deg');
			p.style.setProperty('--fw-dur', (0.6 + Math.random() * 0.8) + 's');
			p.style.setProperty('--fw-delay', bDelay + Math.random() * 0.2 + 's');
			container.appendChild(p);
			p.addEventListener('animationend', function() { this.remove(); });
		}
	}
}

/**
 * Fire continuous fireworks with easing (intense → calming).
 * Returns a stop function.
 */
export function startContinuousFireworks(container, durationMs) {
	injectCss();
	var dur = durationMs || 4000;
	var start = Date.now();
	var timer = setInterval(function() {
		var elapsed = Date.now() - start;
		if (elapsed > dur) { clearInterval(timer); return; }
		var intensity = 1 - (elapsed / dur);
		var bursts = Math.max(1, Math.round(3 * intensity));
		var particles = Math.max(4, Math.round(12 * intensity));
		fireFireworks(container, bursts, particles, 0);
	}, 200);
	return function() { clearInterval(timer); };
}
